import { render, staticRenderFns } from "./AIAssistant.vue?vue&type=template&id=cbf518f0&scoped=true"
import script from "./AIAssistant.vue?vue&type=script&lang=js"
export * from "./AIAssistant.vue?vue&type=script&lang=js"
import style0 from "./AIAssistant.vue?vue&type=style&index=0&id=cbf518f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbf518f0",
  null
  
)

export default component.exports